import React from "react";
import { connect } from "react-redux";
import { PROGRESS, shouldLoadOnUpdate } from "../modules/asyncHttpAction";
import { clearPageTitle } from "../modules/title";
import { trackerActions } from "../modules/tracker";
import { api } from "../modules/api";
import { DashboardEvents } from "../modules/tracker/event-names";
import * as dashboard from "../modules/dashboard";

import DashboardTable, { DashboardNav } from "../components/Dashboard";
import GeneralErrorScreen from "../components/GeneralErrorScreen";
import * as styles from "../styles/components/Dashboard.css";

import Config from "../config";

// ! this component is no longer used, as it simply redirects to the customer-app dashboard
class DashboardContainer extends React.Component {
    constructor(props) {
        window.location.replace(Config.general().betaHost);
        super(props);
    }

    componentDidMount() {
        this.props.listWevos(this.props.teamId);
        this.props.clearPageTitle();
        this.props.trackEnterDashboard(this.props.teamId);
    }

    componentDidUpdate(prevProps) {
        if (
            shouldLoadOnUpdate(this.props.listWevosRequest) ||
            this.props.teamId !== prevProps.teamId
        ) {
            this.props.listWevos(this.props.teamId);
        }
    }

    render() {
        // don't return null while testing to avoid breaking tests
        if (Config.general().nodeEnv !== "test") {
            return null;
        } // prevent old dashboard from rendering while redirect to customer-app dashbaord occurrs
        if (this.props.listWevosRequest === PROGRESS.error) {
            const error = new Error(`Could not get wevos`);
            return (
                <div className={styles.nonIdeal}>
                    <GeneralErrorScreen error={error} />
                </div>
            );
        }

        return (
            <div className={styles.dashboardContainer}>
                <DashboardNav teamId={this.props.teamId} />
                <DashboardTable />
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const { listWevosRequest } = state.dashboard;
    const teamId = dashboard.getTeamIdProp(state, props);
    return {
        teamId,
        listWevosRequest
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        clearPageTitle: () => dispatch(clearPageTitle()),
        listWevos: teamId => dispatch(api.teams.wevos.list(teamId)),
        trackEnterDashboard: teamId =>
            dispatch(
                trackerActions.trackEvent(DashboardEvents.DID_NAVIGATE, {
                    teamId
                })
            )
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardContainer);



// WEBPACK FOOTER //
// ./src/containers/DashboardContainer.js